import { NgModule } from '@angular/core';
import { AgregationService, BundleCall, FlattenService, FormConfigGetter } from './services';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { aggregatorReducer, metaReducers } from './store/reducers/queryData.reducer';
import './utils/arrayUtils';
import { AggregatorEffects } from './store/actions/aggregator.effects';
import { DataBindingHandlerService } from "@ispm-client/modules/aggregator/services/dataBindingHandler.service";
import {WorkflowUtilService} from '@ispm-client/modules/aggregator/services/workflow-util.service';

@NgModule({
  imports: [
    StoreModule.forFeature('bundleData', aggregatorReducer,  { metaReducers }),
    EffectsModule.forFeature([AggregatorEffects])
  ],
  declarations: [],
  providers: [AgregationService, FormConfigGetter, BundleCall, FlattenService,DataBindingHandlerService, WorkflowUtilService],
  exports: []
})
export class AggregatorModule { }
